import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useResource } from "@/lib/api";
import FyTabs from "@/components/FyTabs";
import LedgerGrid from "@/components/ledger/LedgerGrid";

export default function LedgerPage() {
  const { data: fys } = useResource("/financial_years");
  const [params] = useSearchParams();
  const [label, setLabel] = useState(params.get("fy"));
  const fy = (fys || []).find((f) => f.label === label);

  return (
    <div className="rise">
      <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight" data-testid="ledger-title">Ledger</h1>
      <p className="mt-3 text-muted-foreground text-base md:text-lg">
        One tab per financial year. Click any cell to edit, press Enter in the top row to add, or paste rows straight from Excel.
      </p>
      <div className="mt-8"><FyTabs fys={fys} value={label} onChange={setLabel} prefix="ledger" /></div>
      {fy && (
        <div className="mt-6">
          <div className="text-xs font-mono text-muted-foreground mb-4" data-testid="ledger-fy-range">
            {fy.label} · {fy.start_date} to {fy.end_date}
          </div>
          <LedgerGrid key={fy.label} fy={fy} initialFilter={params.get("fy") === fy.label ? params.get("filter") : null} />
        </div>
      )}
    </div>
  );
}
